import { TextInput, CypherState, getState, setState } from "./state";

function xor(a: Uint8Array, b: Uint8Array): Uint8Array {
    if (a.length !== b.length) {
        throw new Error("Uint8Arrays must have the same length");
    }

    const result = new Uint8Array(a.length);
    for (let i = 0; i < a.length; i++) {
        result[i] = a[i] ^ b[i];
    }

    return result;
}

function utf8Tob64(text: string): string {
    let utf8Encode = new TextEncoder();
    let buffer: Uint8Array = utf8Encode.encode(text);
    return bufferToBase64(buffer);
}

function utf8ToBuffer(text: string): Uint8Array {
    let utf8Encode = new TextEncoder();
    return utf8Encode.encode(text);
}

function bufferToBase64(buffer: Uint8Array): string {
    return Buffer.from(buffer).toString('base64');
}

function bufferToString(buffer: Uint8Array): string {
    let utf8Decode = new TextDecoder('utf8');
    return utf8Decode.decode(buffer);
}

function base64ToBuffer(b64: string): Uint8Array {
    return Buffer.from(b64, 'base64');
}

function generatePad(length: number){
    console.log(`Generating pad of length ${length}`);
    const buf = new Uint8Array(length);
    let randomBuffer = window.crypto.getRandomValues(buf);
    return bufferToBase64(randomBuffer);
}

function toBuffer(textInput: TextInput): Uint8Array {
    if (textInput.base64Encoded) {
        return base64ToBuffer(textInput.value);
    }
    return utf8ToBuffer(textInput.value);
}

function fromBuffer(textInput: TextInput, buffer: Uint8Array): TextInput {
    if (textInput.base64Encoded) {
        return {value: bufferToBase64(buffer), base64Encoded: true};
    }
    return {value: bufferToString(buffer), base64Encoded: false};
}

// only call this when the state has been updated with a paste
function defaultCheckboxes(state: CypherState, event?: Event): CypherState {
    const inputBase64Encoded = isValidBase64(state.cleartext.value);
    const pasteEvent: boolean = (event as InputEvent)?.inputType === "insertFromPaste"
    if (inputBase64Encoded && pasteEvent) {
        state.cleartext.base64Encoded = true;
        state.cyphertext.base64Encoded = false;
    } else {
        state.cleartext.base64Encoded = false;
        state.cyphertext.base64Encoded = true;
    }
    return state;
}

function encrypt(state: CypherState): CypherState {
    let clearBuffer = toBuffer(state.cleartext);

    let padBuffer = base64ToBuffer(state.padtext.value);
    let padIndex = 0;

    if (clearBuffer.length > padBuffer.length - padIndex) {
        console.log(clearBuffer);
        console.log(padBuffer);
        console.log(padIndex);
        throw new Error("Need a longer pad");
    }

    let cypherBuffer = xor(clearBuffer, padBuffer.slice(padIndex, clearBuffer.length + padIndex));
    state.cyphertext = fromBuffer(state.cyphertext, cypherBuffer);
    return state;
}

function clearCypher() {
    let state = getState();
    state.cyphertext.value = "";
    setState(state);
}

function clearClearText() {
    let state = getState();
    state.cleartext.value = "";
    setState(state);
}

function isValidBase64(text: string): boolean {
    // Check if the string contains only valid base64 characters and padding
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    return base64Regex.test(text);
}

const update = (event?: Event) => {
    let state = getState();
    if ((event?.target as HTMLElement)?.id === "cleartext") {
        state = defaultCheckboxes(state, event);
        setState(state);
    }
    setState(encrypt(state));
}

const generateButton = document.getElementById("padgen") as HTMLButtonElement;
generateButton.onclick = () => {
    let state = getState();
    state.padtext.value = generatePad(state.padGenerationLength);
    setState(state);
    update();
}

const clearClearButton = document.getElementById("clearcleartext") as HTMLButtonElement;
clearClearButton.onclick = clearClearText;


const elements: HTMLElement[] = [...document.querySelectorAll("input"), ...document.querySelectorAll("textarea")];

document.querySelector("input")?.addEventListener("input", (e) => update());

elements.forEach(element => element.addEventListener("input", (e) => update(e)));
